import { ActionIcon, Box, Menu } from '@mantine/core';
import { User } from '../types';
import { ActionMenuItemProps, ActionMenuItem } from './ActionMenuItem';
import { IconDotsVertical } from '@tabler/icons-react';

export default function ActionMenu({
  menuItems = [],
}: {
  user: User;
  menuItems?: ActionMenuItemProps[];
}) {
  return (
    <Box ta="right">
      <Menu position="bottom-end" withinPortal>
        <Menu.Target>
          <ActionIcon variant="subtle" color="gray">
            <IconDotsVertical size={16} />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown>
          {menuItems.length === 0 && <Menu.Item disabled>No actions available</Menu.Item>}
          {menuItems.map(item => (
            <ActionMenuItem
              key={item.label}
              icon={item.icon}
              label={item.label}
              onClick={item.onClick}
              tooltip={item.tooltip}
              disabled={item.disabled}
            />
          ))}
        </Menu.Dropdown>
      </Menu>
    </Box>
  );
}
